import SvgIcon from '@mui/material/SvgIcon';

export const MenuIcon = () => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4 8H20.043V6H4V8ZM4 13H20.043V11H4V13ZM20.043 18H4V16H20.043V18Z" />
  </SvgIcon>
);
